module.exports = __webpack_public_path__ + "img/inspiration-4@2x.8dfaf58.jpg";